export { default } from './GeonameMapPageMeta';
